import { mdStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const CoinNavStyled = styled.nav`
  margin-bottom: 0px;

  ${mdStyle} {
    margin-bottom: 40px;
  }

  .coin-breadcrumbs--item {
    list-style: none;
    font-weight: 400;
    color: var(--color-text-1);
    &[data-href='true'] {
      color: var(--color-text-3);
    }

    &:hover {
      color: var(--gui-breadcrumb-hover-color);
    }

    a {
      cursor: pointer;
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
    }
  }
`
